
<template>   
    <router-view></router-view>  
</template>
 
<script lang="ts">
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "ComissaoIndex",
        components: {    },  
    }) 
    export default class ComissaoIndex extends Vue {
         
    }
  
</script>
  